import { observer } from "mobx-react-lite";
import { Loader2, Waypoints, X } from "lucide-react";
import type { MapStore } from "@/components/Map/stores/MapStore";

interface ConnectionsBannerProps {
	mapStore: MapStore<any>;
}

export const ConnectionsBanner = observer(({ mapStore }: ConnectionsBannerProps) => {
	const { connectionsStore } = mapStore;
	const fromId = connectionsStore.previewStore.selectedFromMarkerStructureId;
	const isCreating = connectionsStore.createApi.loading;

	if (!fromId && !isCreating) {
		return null;
	}

	return (
		<div className="absolute top-3 left-1/2 -translate-x-1/2 z-20 inline-flex items-center gap-3 bg-white shadow-lg border border-gray-200 rounded-md px-3 py-2 text-sm">
			{isCreating ? (
				<>
					<Loader2 className="h-4 w-4 text-[#003BFF] shrink-0 animate-spin" />
					<span>Creating connection…</span>
				</>
			) : (
				<>
					<Waypoints className="h-4 w-4 text-[#003BFF] shrink-0" />
					<span>
						Click another marker to connect
						<span className="text-muted-foreground"> (Esc to cancel)</span>
					</span>
					<button
						type="button"
						onClick={() => connectionsStore.selectFromMarker(null)}
						aria-label="Exit connection mode"
						className="ml-1 inline-flex items-center justify-center rounded p-1 hover:bg-gray-100 transition-colors"
					>
						<X className="h-4 w-4" />
					</button>
				</>
			)}
		</div>
	);
});
